<ngx-spinner bdColor="rgba(51,51,51,0.8)"
             size="medium"
             color="#fff"
             type="ball-fussion">
    <p class="text">{{LOADING_TEXT}}</p>
</ngx-spinner>
